export const actions = {
  SHOW_GLOBAL_MESSAGE: 'SHOW_GLOBAL_MESSAGE',
  HIDE_GLOBAL_MESSAGE: 'HIDE_GLOBAL_MESSAGE',
  SHOW_PROGRESS_BAR_POP_UP: 'SHOW_PROGRESS_BAR_POP_UP',
  HIDE_PROGRESS_BAR_POP_UP: 'HIDE_PROGRESS_BAR_POP_UP',
};
